import React, { memo, useEffect } from "react";
import AppHeader from "../../Components/AppHeader/AppHeader";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Store/store";
import Footer from "../../Components/Footer/Footer";
import PropertyClaimedModal from "../../Components/Modal/PropertyClaimedModal/PropertyClaimedModal";
import OnboardingManager from "../../Components/Onboarding/OnboardingManager";
import LoginModal from "../../Components/Modal/LoginModal/LoginModal";
import { useLazyGetUserPropertyListQuery, useLazyGetWishlistQuery } from "../../Services/api.user.slice";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";

const PropertyPageLayout = memo(() => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state?.auth || {});
  const [fetchPropertyList] = useLazyGetUserPropertyListQuery();
  const [fetchWishlist] = useLazyGetWishlistQuery();

  // Fetch user data on page load/refresh if authenticated
  useEffect(() => {
    if (isAuthenticated && user?.token) {
      fetchPropertyList("");
      fetchWishlist("");
    }
  }, [isAuthenticated, user?.token, fetchPropertyList, fetchWishlist]);

  return (
    <>
      <ScrollToTop />
      <PropertyClaimedModal />
      <OnboardingManager />
      <LoginModal />
      <AppHeader />
      <Outlet />
      <Footer />
    </>
  );
});

export default PropertyPageLayout;
